__turbopack_context__.v({
  "loaderContainer": "styles-module__6tWAEq__loaderContainer",
  "loaderOverlay": "styles-module__6tWAEq__loaderOverlay",
  "spin": "styles-module__6tWAEq__spin",
  "spinner": "styles-module__6tWAEq__spinner",
});
